import ne from './ne.json';
import en from './en.json';

const translations = {
  ne,
  en
};

export default translations;
